import { mapKeys, upperFirst } from 'lodash';

export const getHighestQualityVideo = videos => {
  const mp4 = videos.filter(video => video.format === 'mp4');
  return mp4.reduce(
    (result, video) => (parseInt(video.quality, 10) > parseInt(result.quality, 10) ? video : result),
    mp4[0],
  );
};

export const createToolbarTheme = (toolbarName, theme) =>
  mapKeys(theme, (value, key) => `${toolbarName}${upperFirst(key)}`);

export const moveArrayItemBeforeTargetItem = (arr, movedItemVal, targetItemVal) => {
  const newArr = [...arr];

  const movelItemIndex = newArr.indexOf(movedItemVal);
  if (movelItemIndex === -1) {
    return arr;
  }

  newArr.splice(movelItemIndex, 1);

  const targetItemIndex = newArr.indexOf(targetItemVal);
  if (targetItemIndex === -1) {
    return arr;
  }

  newArr.splice(targetItemIndex, 1, movedItemVal, targetItemVal);

  return newArr;
};
